import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { Logo } from "../components/Logo";
import { useAdminLang } from "./adminLang";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { tr } = useAdminLang();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("bt_admin_token", res.data.token);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, tr("Identifiants invalides.", "Invalid credentials.")));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#08090A] flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#101214] border border-white/10 rounded-2xl p-8" data-testid="admin-login-form">
        <div className="flex justify-center mb-8"><Logo /></div>
        <h1 className="text-white font-black text-center text-lg">{tr("Administration", "Administration")}</h1>
        <label className="block mt-6 text-xs font-bold uppercase tracking-wider text-white/50" htmlFor="ad-email">{tr("E-mail", "Email")}</label>
        <input id="ad-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input" autoComplete="username"
          className="mt-1.5 w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FF6600]" />
        <label className="block mt-4 text-xs font-bold uppercase tracking-wider text-white/50" htmlFor="ad-pass">{tr("Mot de passe", "Password")}</label>
        <input id="ad-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input" autoComplete="current-password"
          className="mt-1.5 w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#FF6600]" />
        {error && <p className="mt-3 text-xs text-red-400" role="alert" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit"
          className="mt-6 w-full bg-[#FF6600] hover:bg-[#FF9900] disabled:opacity-50 text-[#08090A] font-black rounded-full py-3 text-sm transition-colors">
          {busy ? tr("Connexion…", "Signing in…") : tr("Se connecter", "Sign in")}
        </button>
      </form>
    </div>
  );
};

export default Login;
